module.exports = __webpack_public_path__ + "static/media/jdi.33819eed.svg";